/**
 * User API client
 * Requirements: 14.1, 14.4, 15.1
 */
import { createAuthenticatedClient } from '../../../shared/api/axiosClient';
import type { CreateUserDTO, UserResponse } from '../types/user.types';

const API_BASE_URL = import.meta.env.VITE_API_URL || '';

let apiClient: ReturnType<typeof createAuthenticatedClient> | null = null;

const getApiClient = () => {
  if (!apiClient) {
    apiClient = createAuthenticatedClient(API_BASE_URL, () => {
      window.location.href = '/login';
    });
  }
  return apiClient;
};

export const userApi = {
  /**
   * Create a new user
   */
  async createUser(data: CreateUserDTO): Promise<UserResponse> {
    const client = getApiClient();
    const response = await client.post<UserResponse>('/users', data);
    return response.data;
  },

  /**
   * Get user by ID
   */
  async getUser(userId: string): Promise<UserResponse> {
    const client = getApiClient();
    const response = await client.get<UserResponse>(`/users/${userId}`);
    return response.data;
  },

  /**
   * List all users
   */
  async listUsers(): Promise<UserResponse[]> {
    const client = getApiClient();
    const response = await client.get<UserResponse[]>('/users');
    return response.data;
  },
};
